import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

/* eslint-disable react/no-deprecated */
import React, { Component, Children, cloneElement, createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import { CSSTransition } from 'react-transition-group';
import Checkbox from '../Checkbox';
import Dropdown from '../Dropdown';
import ContentLoader from '../ContentLoader';
import Translate from '../Translate';
import CardButton from './CardButton';
import PreviewPanel from './PreviewPanel';
var VIEW_TILE = 'tile';
var VIEW_EXTENDED = 'extended';
var VIEW_ROW = 'row';
/**
 * @deprecated `Card` component is a part of [CardList](#!/CardList).
 * @since 0.0.54
 */

var Card =
/*#__PURE__*/
function (_Component) {
  _inherits(Card, _Component);

  function Card() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Card)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "rootRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "handleToggleView", function () {
      var view = _this.state.view;

      _this.setState({
        view: view === VIEW_EXTENDED ? VIEW_ROW : VIEW_EXTENDED
      });
    });

    return _this;
  }

  _createClass(Card, [{
    key: "renderSelection",
    value: function renderSelection() {
      var _this$props = this.props,
          baseClassName = _this$props.baseClassName,
          selection = _this$props.selection;

      if (!selection) {
        return null;
      }

      var isSelected = selection.isSelected,
          onSelectionChange = selection.onSelectionChange;
      return React.createElement("div", {
        className: "".concat(baseClassName, "__selection")
      }, React.createElement(Checkbox, {
        checked: isSelected,
        onChange: function onChange(isSelected) {
          return onSelectionChange({
            isSelected: isSelected
          });
        }
      }, this.isExtended() ? React.createElement(Translate, {
        content: "Card.select",
        fallback: "Select"
      }) : null));
    }
  }, {
    key: "renderTitle",
    value: function renderTitle() {
      var _this$props2 = this.props,
          baseClassName = _this$props2.baseClassName,
          title = _this$props2.title,
          titleLink = _this$props2.titleLink;
      var titleLinkProps = typeof titleLink === 'string' ? {
        href: titleLink
      } : titleLink;
      return React.createElement("div", {
        className: "".concat(baseClassName, "__title")
      }, React.createElement("span", {
        className: "".concat(baseClassName, "__title-text")
      }, title), titleLinkProps && React.createElement(CardButton, _extends({
        component: "a",
        icon: "chain",
        tooltip: React.createElement(Translate, {
          content: "Card.titleLinkTooltip",
          fallback: "Go to page"
        })
      }, titleLinkProps)), this.isExtended() && this.renderTitleLabels());
    }
  }, {
    key: "renderTitleLabels",
    value: function renderTitleLabels() {
      var _this$props3 = this.props,
          baseClassName = _this$props3.baseClassName,
          titleLabels = _this$props3.titleLabels;

      if (titleLabels.length === 0) {
        return null;
      }

      return React.createElement("div", {
        className: "".concat(baseClassName, "__title-labels")
      }, Children.map(titleLabels, function (label) {
        return cloneElement(label, {
          className: classNames("".concat(baseClassName, "__label"), label.props.className)
        });
      }));
    }
  }, {
    key: "renderLabels",
    value: function renderLabels() {
      var _this$props4 = this.props,
          baseClassName = _this$props4.baseClassName,
          labels = _this$props4.labels;

      if (labels.length === 0) {
        return null;
      }

      return React.createElement("div", {
        className: "".concat(baseClassName, "__labels")
      }, Children.map(labels, function (label) {
        return cloneElement(label, {
          className: classNames("".concat(baseClassName, "__label"), label.props.className)
        });
      }));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var baseClassName = this.props.baseClassName;
      return React.createElement("div", {
        className: "".concat(baseClassName, "__header")
      }, this.renderSelection(), this.renderTitle(), this.isExtended() && this.renderLabels(), this.renderButtons());
    }
  }, {
    key: "renderRowHeader",
    value: function renderRowHeader() {
      var _this$props5 = this.props,
          baseClassName = _this$props5.baseClassName,
          subtitle = _this$props5.subtitle;
      return React.createElement("div", {
        className: "".concat(baseClassName, "__header")
      }, subtitle && React.createElement("div", {
        className: "".concat(baseClassName, "__subtitle")
      }, subtitle), this.renderTitle());
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props6 = this.props,
          baseClassName = _this$props6.baseClassName,
          children = _this$props6.children;
      return React.createElement("div", {
        className: "".concat(baseClassName, "__main")
      }, React.createElement("div", {
        className: "".concat(baseClassName, "__main-content")
      }, children));
    }
  }, {
    key: "isExtended",
    value: function isExtended() {
      var view = this.state.view;
      return !this.isTile() && view === VIEW_EXTENDED;
    }
  }, {
    key: "isTile",
    value: function isTile() {
      var view = this.state.view;
      return view === VIEW_TILE;
    }
  }, {
    key: "isRow",
    value: function isRow() {
      var view = this.state.view;
      return !this.isTile() && view === VIEW_ROW;
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      var _this$props7 = this.props,
          baseClassName = _this$props7.baseClassName,
          rowContent = _this$props7.rowContent,
          menu = _this$props7.menu,
          buttons = _this$props7.buttons;
      var result = [];

      if (!this.isRow()) {
        buttons.forEach(function (btn, index) {
          result.push(React.createElement(CardButton, _extends({
            key: btn.key || index
          }, btn)));
        });
      }

      if (menu) {
        result.push(React.createElement(Dropdown, {
          key: "menu",
          menu: menu,
          menuPlacement: 'bottom-end'
        }, React.createElement(CardButton, {
          icon: "menu"
        })));
      }

      if (rowContent && !this.isTile()) {
        result.push(React.createElement(CardButton, {
          key: "toggleView",
          icon: {
            name: 'chevron-down',
            flipVertical: this.isExtended()
          },
          onClick: this.handleToggleView,
          tooltip: this.isExtended() ? React.createElement(Translate, {
            content: "Card.collapseCardTooltip",
            fallback: "Collapse the card"
          }) : React.createElement(Translate, {
            content: "Card.expandCardTooltip",
            fallback: "Expand the card"
          })
        }));
      }

      if (result.length === 0) {
        return null;
      }

      return React.createElement("div", {
        className: "".concat(baseClassName, "__buttons")
      }, result);
    }
  }, {
    key: "renderSideHeader",
    value: function renderSideHeader() {
      var _this$props8 = this.props,
          sideHeader = _this$props8.sideHeader,
          baseClassName = _this$props8.baseClassName;

      if (!sideHeader) {
        return null;
      }

      var sideHeaderElement = sideHeader;

      if (sideHeader.type === PreviewPanel) {
        var props = {
          className: classNames(sideHeader.props.className, "".concat(baseClassName, "__preview-panel"))
        };

        if (this.isRow()) {
          props.children = null;
        }

        sideHeaderElement = cloneElement(sideHeader, props);
      }

      return React.createElement("div", {
        className: "".concat(baseClassName, "__side-header")
      }, sideHeaderElement);
    }
  }, {
    key: "renderSideContent",
    value: function renderSideContent() {
      var _this$props9 = this.props,
          sideContent = _this$props9.sideContent,
          baseClassName = _this$props9.baseClassName;

      if (!sideContent) {
        return null;
      }

      return React.createElement("div", {
        className: "".concat(baseClassName, "__side-content")
      }, sideContent);
    }
  }, {
    key: "renderRow",
    value: function renderRow() {
      var _this$props10 = this.props,
          baseClassName = _this$props10.baseClassName,
          rowContent = _this$props10.rowContent;
      return React.createElement("div", {
        className: "".concat(baseClassName, "__inner")
      }, React.createElement("div", {
        className: "".concat(baseClassName, "__body")
      }, this.renderSelection(), this.renderSideHeader(), this.renderRowHeader(), React.createElement("div", {
        className: "".concat(baseClassName, "__main")
      }, React.createElement("div", {
        className: "".concat(baseClassName, "__main-content")
      }, rowContent)), this.renderButtons()));
    }
  }, {
    key: "renderTile",
    value: function renderTile() {
      var baseClassName = this.props.baseClassName;
      return React.createElement("div", {
        className: "".concat(baseClassName, "__inner")
      }, this.renderHeader(), React.createElement("div", {
        className: "".concat(baseClassName, "__body")
      }, this.renderSideHeader(), this.renderContent()), this.renderSideContent());
    }
  }, {
    key: "renderExtended",
    value: function renderExtended() {
      var baseClassName = this.props.baseClassName;
      var sideHeaderElement = this.renderSideHeader();
      var sideContentElement = this.renderSideContent();
      return React.createElement("div", {
        className: "".concat(baseClassName, "__inner")
      }, this.renderHeader(), React.createElement("div", {
        className: "".concat(baseClassName, "__body")
      }, sideHeaderElement || sideContentElement ? React.createElement("div", {
        className: "".concat(baseClassName, "__side")
      }, sideHeaderElement, sideContentElement) : null, this.renderContent()));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props11 = this.props,
          baseClassName = _this$props11.baseClassName,
          className = _this$props11.className,
          children = _this$props11.children,
          view = _this$props11.view,
          intent = _this$props11.intent,
          title = _this$props11.title,
          subtitle = _this$props11.subtitle,
          titleLink = _this$props11.titleLink,
          titleLabels = _this$props11.titleLabels,
          selection = _this$props11.selection,
          rowContent = _this$props11.rowContent,
          sideHeader = _this$props11.sideHeader,
          sideContent = _this$props11.sideContent,
          buttons = _this$props11.buttons,
          menu = _this$props11.menu,
          labels = _this$props11.labels,
          progress = _this$props11.progress,
          props = _objectWithoutProperties(_this$props11, ["baseClassName", "className", "children", "view", "intent", "title", "subtitle", "titleLink", "titleLabels", "selection", "rowContent", "sideHeader", "sideContent", "buttons", "menu", "labels", "progress"]);

      return React.createElement(CSSTransition, {
        classNames: "".concat(baseClassName, "-"),
        in: this.isExtended(),
        timeout: 300,
        nodeRef: this.rootRef
      }, React.createElement("div", _extends({
        className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--extended"), this.isExtended()), _defineProperty(_classNames, "".concat(baseClassName, "--tile"), this.isTile()), _defineProperty(_classNames, "".concat(baseClassName, "--row"), this.isRow()), _defineProperty(_classNames, "".concat(baseClassName, "--").concat(intent), intent), _defineProperty(_classNames, "".concat(baseClassName, "--progress"), progress), _classNames), className)
      }, props, {
        ref: this.rootRef
      }), this.isExtended() && this.renderExtended(), this.isTile() && this.renderTile(), this.isRow() && this.renderRow(), progress && React.createElement(ContentLoader, {
        overlay: true,
        backdrop: true,
        text: progress === true ? null : progress
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var view = props.view;
      var prevView = state.prevView;
      var nextState = {};

      if (view !== prevView) {
        nextState.view = view;
      }

      nextState.prevView = view;
      return nextState;
    }
  }]);

  return Card;
}(Component);

Card.propTypes = {
  /**
   * Content of the `Card`.
   * @since 0.0.54
   */
  children: PropTypes.node,

  /**
   * View mode.
   * @since 0.0.54
   */
  view: PropTypes.oneOf([VIEW_EXTENDED, VIEW_TILE, VIEW_ROW]),

  /**
   * Visual intent color to apply to component.
   * @since 0.0.54
   */
  intent: PropTypes.oneOf(['warning', 'danger', 'inactive']),

  /**
   * Text of title.
   * @since 0.0.54
   */
  title: PropTypes.node.isRequired,

  /**
   * Link for title.
   * @since 0.0.54
   */
  titleLink: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /**
   * List of labels in header, which should appear right after the title. See [Label](#!/Label) component for details.
   * @since 1.6.0
   */
  titleLabels: PropTypes.arrayOf(PropTypes.element),

  /**
   * Text of subtitle.
   * @since 0.0.54
   */
  subtitle: PropTypes.node,

  /**
   * List of labels in header, which should appear at the end of header. See [Label](#!/Label) component for details.
   * @since 0.0.54
   */
  labels: PropTypes.arrayOf(PropTypes.element),

  /**
   * List of additional buttons in header.
   * @since 0.0.54
   */
  buttons: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]).isRequired,
    onClick: PropTypes.func.isRequired,
    tooltip: PropTypes.node
  })),

  /**
   * See [Menu](#!/Menu).
   * @since 0.3.0
   */
  menu: PropTypes.element,

  /**
   * Selection control.
   * @since 0.0.54
   */
  selection: PropTypes.shape({
    isSelected: PropTypes.bool.isRequired,
    onSelectionChange: PropTypes.func.isRequired
  }),

  /**
   * Side header section. Recommended to use [PreviewPanel](#!/PreviewPanel) component.
   * @since 0.0.54
   */
  sideHeader: PropTypes.element,

  /**
   * Side content section.
   * @since 0.0.54
   */
  sideContent: PropTypes.element,

  /**
   * Content for row view.
   * @since 0.0.54
   */
  rowContent: PropTypes.any,

  /**
   * Indicate the progress state of the card.
   * @since 0.4.1
   */
  progress: PropTypes.oneOfType([PropTypes.bool, PropTypes.node]),

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  baseClassName: PropTypes.string
};
Card.defaultProps = {
  children: null,
  view: VIEW_EXTENDED,
  intent: null,
  subtitle: '',
  titleLink: null,
  titleLabels: [],
  labels: [],
  buttons: [],
  menu: null,
  selection: null,
  sideHeader: null,
  sideContent: null,
  rowContent: null,
  progress: false,
  className: null,
  baseClassName: "".concat(CLS_PREFIX, "card")
};
export default Card;